var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedPerson({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 15.667H3.58333C3.16666 15.667 2.75 15.417 2.58333 15.0837C2.33333 14.7503 2.33333 14.417 2.5 14.0003C3.5 11.667 5.75 10.0837 8.33333 10.0837C10.9167 10.0837 13.0833 7.91699 13.0833 5.33366C13.0833 2.75033 10.9167 0.666992 8.25 0.666992C5.66667 0.666992 3.5 2.83366 3.5 5.41699C3.5 6.91699 4.16666 8.25033 5.25 9.08366C3.33333 9.83366 1.66666 11.417 0.833331 13.417C0.499998 14.2503 0.583331 15.2503 1.08333 16.0003C1.66666 16.8337 2.5 17.3337 3.5 17.3337H8.25C8.75 17.3337 9.08333 17.0003 9.08333 16.5003C9.08333 16.0003 8.75 15.667 8.33333 15.667ZM5.16667 5.41699C5.16667 3.75033 6.58333 2.33366 8.25 2.33366C9.91667 2.33366 11.3333 3.75033 11.3333 5.41699C11.3333 7.08366 9.91667 8.50033 8.25 8.50033C6.58333 8.50033 5.16667 7.08366 5.16667 5.41699Z",
    fill: "#505054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.66699C16.5833 9.41699 16.0833 9.50033 15.8333 9.91699L12.3333 15.0837L11 13.3337C10.75 13.0003 10.1667 12.917 9.83333 13.167C9.5 13.417 9.41666 14.0003 9.66666 14.3337L11.75 17.0837C11.9167 17.3337 12.1667 17.417 12.4167 17.417C12.6667 17.417 12.9167 17.2503 13.0833 17.0837L17.1667 10.917C17.4167 10.417 17.3333 9.91699 17 9.66699Z",
    fill: "#505054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedPerson);
export default __webpack_public_path__ + "static/media/checked-person.38220b14faacb1835ef32c2a70d3b205.svg";
export { ForwardRef as ReactComponent };